export const tr = {
    'campaign-events': 'Bu kampanyaya ait işlemler',
    'change-traffic-value': 'Trafik hacmi değiştirme',
    'current-balance': 'Kalan bakiye',
    'email-empty': 'E-posta adresi belirtilmedi',
    'end-campaign': 'Kampanya bitişi hakkında',
    'increase-balance': 'Bakiye artırma',
    'moderation-results': 'Moderasyon sonuçları hakkında',
    'monitoring-results': 'Site izleme sonuçları hakkında',
    'percent-of-current-balance': 'Kampanyada kalan bakiye seviyesi',
    'percent-of-current-balance-warning-empty': 'Kalan bakiye seviyesi belirtilmedi',
    'percent-of-current-balance-warning-interval': 'Kalan bakiye seviyesi {min} ile {max} arasında olmalıdır',
    'stop-by-reach-daily-budget': 'Günlük bütçeye ulaşıldığında duraklama',
    'xls-ready': 'XLS raporlarının hazır olması'
};
